<template>
  <div class="system-logs-container">
    <v-card flat class="futuristic-card">
      <div class="card-header">
        <h1 class="text-md-center earth-color">SYSTEM WIDE LOGS</h1>
        <div class="title-decoration"></div>
      </div>
      <v-card-title>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          placeholder="Search system logs..."
          single-line
          hide-details
          v-model="search"
          class="futuristic-input"
        ></v-text-field>
      </v-card-title>
      <v-data-table
        :headers="columns"
        :items="allLogs"
        :search="search"
        :rows-per-page-items="[10, 25, { text: 'All', value: -1 }]"
        :disable-initial-sort="true"
        :loading="$loadingTrue"
        class="futuristic-table"
      >
        <v-progress-linear
          slot="progress"
          color="#587e27"
          indeterminate
          height="3"
        ></v-progress-linear>
        <template slot="items" slot-scope="props">
          <td>{{ formated_date_time(props.item.request_time) }}</td>
          <td class="font-weight-medium">{{ props.item.user }}</td>
          <td>{{ props.item.request_url }}</td>
          <td>
            <v-chip 
              small 
              :color="getMethodColor(props.item.request_method)"
              text-color="white"
              class="method-chip"
            >
              {{ props.item.request_method }}
            </v-chip>
          </td>
          <td>
            <v-chip 
              small 
              :color="getStatusCodeColor(props.item.request_status_code)"
              text-color="white"
              class="status-chip"
            >
              {{ props.item.request_status_code }}
            </v-chip>
          </td>
          <td>{{ props.item.user_agent_info[0].agent_browser }}</td>
          <td>{{ props.item.user_agent_info[0].agent_platform }}</td>
          <td>{{ props.item.request_source }}</td>
        </template>
        <v-alert slot="no-results" :value="true" color="error" icon="warning" class="futuristic-alert">
          Your search for "{{ search }}" found no results.
        </v-alert>
      </v-data-table>
    </v-card>
  </div>
</template>

<script>
export default {
  name: "AllLogs",
  data() {
    return {
      search: "",
      columns: [
        {
          text: "Time In",
          value: "request_time",
          class: "table-header"
        },
        {
          text: "User",
          value: "user",
          class: "table-header"
        },
        {
          text: "URLs",
          value: "request_url",
          class: "table-header"
        },
        {
          text: "Request Method",
          value: "request_method",
          class: "table-header"
        },
        {
          text: "Request Status",
          value: "request_status_code",
          class: "table-header"
        },
        {
          text: "Browser",
          value: "user_agent_info[0].agent_browser",
          class: "table-header"
        },
        {
          text: "Platform",
          value: "user_agent_info[0].agent_platform",
          class: "table-header"
        },
        {
          text: "IP",
          value: "request_source",
          class: "table-header"
        },
      ],
    };
  },
  created() {
    this.$store.dispatch("get_all_logs");
  },
  methods: {
    getMethodColor(method) {
      if (method === 'GET') return '#2196f3';
      if (method === 'POST') return '#4caf50';
      if (method === 'PUT' || method === 'PATCH') return '#ff9800';
      if (method === 'DELETE') return '#f44336';
      return '#9e9e9e';
    },
    getStatusCodeColor(statusCode) {
      if (statusCode >= 200 && statusCode < 300) return '#4caf50';
      if (statusCode >= 300 && statusCode < 400) return '#2196f3';
      if (statusCode >= 400 && statusCode < 500) return '#ff9800';
      if (statusCode >= 500) return '#f44336';
      return '#9e9e9e';
    }
  },
};
</script>

<style scoped>
.system-logs-container {
  background: #ffffff;
  border-radius: 8px;
  padding: 16px;
  transition: all 0.3s ease;
}

.system-logs-container:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.card-header {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa);
  padding: 16px;
  border-radius: 8px;
  margin-bottom: 20px;
}

.earth-color {
  color: #587e27;
  font-weight: 600;
  margin: 0;
  font-size: 2rem;
}

.title-decoration {
  height: 4px;
  background: linear-gradient(90deg, #587e27, transparent);
  margin-bottom: 16px;
  width: 100px;
}

.futuristic-card {
  border-radius: 8px;
  background: #ffffff;
  transition: all 0.3s ease;
  overflow: hidden;
}

.futuristic-card:hover {
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.1);
}

.futuristic-input >>> .v-input__slot {
  border-radius: 8px;
  background: #f5f7fa;
}

.method-chip {
  border-radius: 12px;
  font-weight: 500;
  min-width: 60px;
  justify-content: center;
}

.status-chip {
  border-radius: 12px;
  font-weight: 500;
  min-width: 50px;
  justify-content: center;
}

.futuristic-alert {
  border-radius: 8px;
  margin: 16px;
}

/* Table styling */
.futuristic-table >>> thead tr th {
  background: linear-gradient(45deg, #e8eaf6, #f5f7fa) !important;
  color: #587e27 !important;
  font-weight: 600;
  font-size: 14px;
}

.futuristic-table >>> tbody tr:nth-of-type(even) {
  background-color: #f9f9f9;
}

.futuristic-table >>> tbody tr:hover {
  background-color: #f0f4f8 !important;
}

/* Responsive adjustments */
@media (max-width: 960px) {
  .system-logs-container {
    padding: 12px;
  }

  .card-header {
    padding: 12px;
  }

  .earth-color {
    font-size: 1.75rem;
  }
}

@media (max-width: 600px) {
  .system-logs-container {
    padding: 8px;
    border-radius: 6px;
  }

  .card-header {
    padding: 8px;
  }

  .earth-color {
    font-size: 1.5rem;
  }
}
</style>